<template>
  <div>
    <div>
      <slot name="title">
        <span class="text-h6">
          {{ title }}
        </span>
      </slot>
    </div>

    <div>
      <slot name="description">
        <span>
          {{ description }}
        </span>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped></style>
